import { render } from "./AnnotationReview.vue?vue&type=template&id=be7ed59e&scoped=true"
import script from "./AnnotationReview.vue?vue&type=script&lang=js"
export * from "./AnnotationReview.vue?vue&type=script&lang=js"

import "./AnnotationReview.vue?vue&type=style&index=0&id=be7ed59e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7ed59e"]])

export default __exports__